import { detect } from 'detect-browser'

const browser = detect()
export const convertToMp4 = browser?.name === "safari" || browser?.name === "ios" || browser?.os === "iOS"